export enum ERegistrationStep {
	BUSINESS = 'business',
	USER = 'user',
	CONFIGURING = 'configuring',
	FINALIZING = 'finalizing',
}

export enum ERegistrationStatus {
	PENDING = 'pending',
	IN_PROGRESS = 'in_progress',
	COMPLETED = 'completed',
	FAILED = 'failed',
}

export interface ProgressStepsState {
	[ERegistrationStep.BUSINESS]: ERegistrationStatus;
	[ERegistrationStep.USER]: ERegistrationStatus;
	[ERegistrationStep.CONFIGURING]: ERegistrationStatus;
	[ERegistrationStep.FINALIZING]: ERegistrationStatus;
}
